// TODO(FE-653): Replace workaround patch for cache eviction conflict bug.
export const ensureSafeDateType = (date: Date) => {
    return typeof date === 'string' ? new Date(date) : date;
};
